import React, { Component } from 'react';
import { routerActions } from 'connected-react-router';
import { withRouter } from 'react-router-dom';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import {Table, Dropdown, Checkbox, Form} from 'semantic-ui-react';
import DatePicker from '../../components/DatePicker';
import RefreshButton from '../../components/RefreshButton';
import * as Reservation from '../../store/Reservations';
import * as Events from '../../store/Events';
import * as Facilities from '../../store/Facility';
import moment from 'moment';
class InventoryList extends Component {
    constructor(props) {
        super(props);
        this.state = {
            facilityId: '',
            eventId: 'all',
            filterDate: 'all',
            filterDt: moment()
        }
        this.onFilter = this.onFilter.bind(this);
        this.onEdit = this.onEdit.bind(this);
    }

    async onFilter(e, {name, value}) {
        const {actions} = this.props;
        const {filterDt} = this.state;
        this.setState({[name]: value});
        console.log(name);
        if (name === 'filterDate' || name === 'filterDt')
        {
            if (name === 'filterDate' && value === 'all'){
                return await actions.getInventoryList();
            }

            await actions.getInventoryList((name === 'filterDt' ? value : filterDt).toISOString());
        }
    }
    onEdit(e) {
        e.preventDefault();
        const {actions} = this.props;
        actions.push(e.target.pathname);
    }
    
    render() {
        const {inventory, events, actions} = this.props;
        const {eventId, filterDate, filterDt} = this.state;

        console.log(inventory);

        return (
            <div>
                <Table>
                    <Table.Header>
                        <Table.Row>
                            <Table.HeaderCell colSpan={6}>
                            <Form>
                            <Form.Group inline style={{margin: 0}}>
                            <div style={{marginRight: 15}}>Inventory </div>
                            <Checkbox style={{marginRight: 15}} radio label="All Dates" name="filterDate" value="all" checked={filterDate === 'all'} onChange={this.onFilter} /> 
                            <Checkbox style={{marginRight: 15}} radio label="Select Date" name="filterDate" value="filtered" checked={filterDate === 'filtered'} onChange={this.onFilter} />
                            <DatePicker
                            name="filterDt"
                            placeholderText="Filter"
                            selected={filterDt}
                            onChange={this.onFilter}
                            showYearDropdown
                            showMonthDropdown
                            scrollableYearDropdown
                            timeIntervals={15}
                            disabled={filterDate === 'all'}
                            dateFormat="LL" />
                            </Form.Group>
                            
                            </Form>
                            
                            </Table.HeaderCell>
                            <Table.HeaderCell><RefreshButton floated="right" action={async () => await actions.getInventoryList()} /></Table.HeaderCell>
                        </Table.Row>
                        <Table.Row>
                            <Table.HeaderCell>
                                <Dropdown selection fluid name='eventId' value={eventId} options={[{text: 'All', value: 'all'}, ...events]} onChange={this.onFilter} />
                            </Table.HeaderCell>
                            <Table.HeaderCell>Facility</Table.HeaderCell>
                            <Table.HeaderCell>Block</Table.HeaderCell>
                            <Table.HeaderCell>Total Spots</Table.HeaderCell>
                            <Table.HeaderCell>Open Spots</Table.HeaderCell>
                            <Table.HeaderCell>Pending Spots</Table.HeaderCell>
                            <Table.HeaderCell>Paid Spots</Table.HeaderCell>
                        </Table.Row>
                    </Table.Header>
                    <Table.Body>
                        {inventory.sort((a, b) => {
                           if (a.eventName > b.eventName) return 1;
                           if (a.eventName < b.eventName) return -1;
                           if (a.facilityName > b.facilityName) return 1;
                           if (a.facilityName < b.facilityName) return -1;
                           if (a.inventoryBlockName > b.inventoryBlockName) return 1;
                           if (a.inventoryBlockName < b.inventoryBlockName) return -1;
                           return 0;
                        }).filter(i => eventId === 'all' ? true : i.eventId === eventId)
                        .map((r, index) => (
                            <Table.Row>
                                <Table.Cell>{r.eventName}</Table.Cell>
                                <Table.Cell>{r.facilityName}</Table.Cell>
                                <Table.Cell>{r.inventoryBlockName}</Table.Cell>
                                <Table.Cell>{r.totalSpots}</Table.Cell>
                                <Table.Cell>{r.openSpots}</Table.Cell>
                                <Table.Cell>{r.pendingSpots}</Table.Cell>
                                <Table.Cell>{r.paidSpots}</Table.Cell>
                            </Table.Row>
                        ))}
                    </Table.Body>
                    <Table.Footer>
                        <Table.Row>
                        <Table.HeaderCell colspan={7}></Table.HeaderCell>
                        </Table.Row>
                    </Table.Footer>
                </Table>
            </div>
        );
    }
}

InventoryList.propTypes = {

};

const mapStateToProps = (state, ownProps) => {
    return {
        inventory: Object.values(Reservation.selector(state).inventory),
        events: Object.values(Events.selector(state).events).map(evt => ({value: evt.id, text: evt.name})),
        facilities: Object.values(Facilities.selector(state).facilities).map(f => ({value: f.id, text: f.name})),
    }
}

const mapDispatchToProps = (dispatch) => ({
    actions: {
        ...bindActionCreators(routerActions, dispatch),
        ...bindActionCreators(Reservation.actionCreators, dispatch),
    }
})

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(InventoryList));